/**
 * @module app.shared
 */

import { autoinject, customAttribute } from 'aurelia-framework';

@autoinject
@customAttribute('direct-focus-input')
export class DirectFocusInputCustomAttribute {

  ////****************** Fields and Properties ************************************////
  public value: HTMLElement | null = null;

  ////****************** Element References ***************************************////

  ////****************** Lifecycle events (in order of execution) *****************////
  constructor(protected readonly element: Element) { }

  protected attached(): void {
    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  protected detached(): void {
    this.element.removeEventListener("click", this.handleClick.bind(this));
  }

  ////****************** Functions ************************************************////
  protected handleClick(event: MouseEvent): void {
    if(this.value?.tagName === 'INPUT') {
      this.value.focus();
    } else {
      requestAnimationFrame(() => {
        this.value?.querySelector('input')?.focus();
      });
    }

  }
}
